export default __webpack_public_path__ + "static/media/pen-icon.9b9d5e1c.svg";